/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskSessionQuarantinesListSessionQuarantines } from "../funcs/riskSessionQuarantinesListSessionQuarantines.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListSessionQuarantinesResult } from "../models/components/listsessionquarantinesresult.js";
import {
  ListSessionQuarantinesRequest,
  ListSessionQuarantinesSecurity,
} from "../models/operations/listsessionquarantines.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskListSessionQuarantinesQueryData = ListSessionQuarantinesResult;

export function prefetchRiskListSessionQuarantines(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSessionQuarantinesRequest | undefined,
  security?: ListSessionQuarantinesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskListSessionQuarantinesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskListSessionQuarantinesQuery(
  client$: GramCore,
  request?: ListSessionQuarantinesRequest | undefined,
  security?: ListSessionQuarantinesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RiskListSessionQuarantinesQueryData>;
} {
  return {
    queryKey: queryKeyRiskListSessionQuarantines({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskListSessionQuarantinesQueryFn(
      ctx,
    ): Promise<RiskListSessionQuarantinesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskSessionQuarantinesListSessionQuarantines(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskListSessionQuarantines(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "sessionQuarantines",
    "listSessionQuarantines",
    parameters,
  ];
}
